import { Point } from './geometryTypes';

export const distanceFourArgs = (
  x1: number,
  y1: number,
  x2: number,
  y2: number
) => ((x1 - x2) ** 2 + (y1 - y2) ** 2) ** 0.5;

export const distanceTwoArgs = ([ax, ay]: Point, [bx, by]: Point) =>
  distanceFourArgs(ax, ay, bx, by);
